import {CampaignDTO} from "./types";

export function createOrUpdatePetitionFetchCounter(campaign: CampaignDTO, startFn: () => void, times: number) {
    let div = document.querySelector(".petition_fetch_counter");
    if (!div) {
        div = document.createElement('div');
        div.className = 'petition_fetch_counter rounded-full drop-shadow-lg';
        const body = document.querySelector("body");
        body.appendChild(div);
    }
    if (campaign.ui.email_poll_count <= 0) {
        div.innerHTML = '<i class="bx bx-envelope"></i> <i class="bx bx-play"></i>';
        div.addEventListener('click', startFn, {once: true});
        div.classList.add('cursor-pointer');
    } else {
        div.innerHTML = '<i class="bx bx-envelope"></i> ' + times.toString();
        div.classList.remove('cursor-pointer');
    }
}
